import type { ShowcaseItem } from './types/showcase';

export const homeShowcase: ShowcaseItem[] = [
  { kind: 'work', id: 'sais', layout: 'featured' },
  { kind: 'work', id: 'crf', layout: 'compact' },
  { kind: 'work', id: 'cuendo', layout: 'compact' },
];
